import SubscriptionPackageContainer  from 'scripts/defa/subscription-packages/view-subscription-package-container';
import SubscriptionPackageOptionForm from 'scripts/defa/subscription-packages/view-subscription-package-option-form';
import template from 'templates/subscriptionPackagePrepaidFlow.jst.html'

/**
 * defa.views.SubscriptionPackagePrepaidFlow
 * A flow for selecting prepaid subscription packages.
 * @version 1.2.0
 */
import Flow                          from 'scripts/poppet/flow';

const selectors = {
	region  : '[data-region=subscription-package-container]',
};

const SubscriptionPackagePrepaidFlow = Flow.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.region,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView requests to change the subscription package.
	 * @void
	 */
	onChildviewChange: function () {
		this.subscriptionPackageOption = true;
		this.dispatch();
	},
	
	/**
	 * Triggers when a childView requests to clear the subscription package.
	 * @void
	 */
	onChildviewClear: function () {
		this.trigger( 'prepaidPackage:clear' );
	},
	
	/**
	 * Triggers when a childView requests to skip the subscription package.
	 * @void
	 */
	onChildviewSkip: function () {
		this.trigger( 'prepaidPackage:skip' );
	},
	
	/**
	 * Triggers when a childView has selected a subscriptionPackage.
	 * @void
	 */
	onChildviewSubscriptionPackageSelected: function ( id ) {
		this.trigger( 'prepaidPackage:selected', id );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Dispaches the prepaid subscription flow.
	 * @void
	 */
	dispatch: function () {
		
		let fn   = false,
			self = this;
		
		if ( !self.subscriptionPackageOption ) {
			var noPromotion = self.options.subscriptionPackages.some( function( model ) {
				return model.get( 'transientPromotion' ) === false
			});
			
			if ( !noPromotion ) {
				this.options.hidePromotion = true;
				fn = self._showSubscripionPackageSelection;
			} else {
				fn = self._showSubscriptionPackageOption;
			}
		}
		
		if ( self.subscriptionPackageOption ) {
			fn = self._showSubscripionPackageSelection;
		}
		
		
		if ( _.isFunction( fn ) ) {
			fn.call( this );
		}
		
	},
	
	/**
	 * Shows the options for subscription packages.
	 * @void
	 */
	_showSubscriptionPackageOption: function () {
		
		let subscriptionPackageOptionForm = new SubscriptionPackageOptionForm( {
			model: this.options.unit,
		} );
		
		this.showChildView( 'container', subscriptionPackageOptionForm );
	},
	
	/**
	 * Shows subscription packages to select from.
	 * @void
	 */
	_showSubscripionPackageSelection: function () {
		
		let subscriptionPackageContainer = new SubscriptionPackageContainer( {
			prepaid   : true,
			unit      : this.options.unit,
			installer : this.options.installer,
			collection: this.options.subscriptionPackages,
			hidePromotion: this.options.hidePromotion  || false,
		} );
		
		this.showChildView( 'container', subscriptionPackageContainer );
	},
	
} );

export default SubscriptionPackagePrepaidFlow;